module.exports = __webpack_public_path__ + "static/media/slide4.24470136.jpg";